const CPF_LENGTH = 11;

const ALPHANUMERIC_REGEX = /[^0-9A-Z]/g;
const LETTER_REGEX = /[A-Z]/;

const ALPHANUMERIC_MASK = /[0-9A-Za-z]/;
const DIGIT_MASK = /\d/;

const createDocumentMask = (length, mask) => Array(length).fill(mask);

const CPF_DOCUMENT_MASK = [
  ...createDocumentMask(3, DIGIT_MASK),
  '.',
  ...createDocumentMask(3, DIGIT_MASK),
  '.',
  ...createDocumentMask(3, DIGIT_MASK),
  '-',
  ...createDocumentMask(2, DIGIT_MASK),
];

const CNPJ_DOCUMENT_MASK = [
  ...createDocumentMask(2, ALPHANUMERIC_MASK),
  '.',
  ...createDocumentMask(3, ALPHANUMERIC_MASK),
  '.',
  ...createDocumentMask(3, ALPHANUMERIC_MASK),
  '/',
  ...createDocumentMask(4, ALPHANUMERIC_MASK),
  '-',
  DIGIT_MASK,
  DIGIT_MASK,
];

const cleanDocumentMask = (value) => {
  return (value || '').toUpperCase().replace(ALPHANUMERIC_REGEX, '');
};

const shouldUseCnpjMask = (value) => {
  const rawValue = cleanDocumentMask(value);

  return LETTER_REGEX.test(rawValue) || rawValue.length > CPF_LENGTH;
};

export const getDocumentMask = (value) => {
  return shouldUseCnpjMask(value) ? CNPJ_DOCUMENT_MASK : CPF_DOCUMENT_MASK;
};

export const normalizeDocumentMask = (value) => {
  return value.toUpperCase();
};
